export const isloggedIn = () => {
    const token = localStorage.getItem('Authentication') ? JSON.parse(localStorage.getItem('Authentication')).access_token : null;

    if (!token) {
        return false;
    } else {
        return true;
    }
};
export const isIos = () => {
    return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
            navigator.platform,
        ) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
};

export const onErrorImages = (e) => {
    e.target.src = "/assets/images/default-image.svg"
};
export const transformMonthName = (e) => {

    let month = parseInt(e.split('/')[1]);
    let year = parseInt(e.split('/')[0]);
    let day = parseInt(e.split('/')[2]);

    const AllMonth = [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند"
    ];
    let value = day + ' ' + AllMonth[month - 1] + ' ' + year;
    return value;
}

export const numberSessionsToLetter = (num) => {

    const AllDays = [
        "اول",
        "دوم",
        "سوم",
        "چهارم",
        "پنجم",
        "ششم",
        "هفتم",
    ];
    const value = AllDays[num - 1];
    return value;
}

export const returnWeekDays = (dayValue, type = 'fa') => {

    const AllFaDays = {
        saturday: "شنبه",
        sunday: "یکشنبه",
        monday: "دوشنبه",
        tuesday: "سه‌شنبه",
        wednesday: "چهارشنبه",
        thursday: "پنجشنبه",
        friday: "جمعه",
    };
    const AllEnDays = {
        1: 'saturday',
        2: 'sunday',
        3: 'monday',
        4: 'tuesday',
        5: 'wednesday',
        6: 'thursday',
        7: 'friday',
    };
    let day = null;
    if (type == 'fa') {
        day = (AllFaDays[`${dayValue.toLowerCase()}`]);
    } else {
        day = (AllEnDays[`${dayValue.toLowerCase()}`]);
    }
    return day;
}

export const returnWeekDaysNumber = (dayValue) => {

    const AllEnDays = {
        'saturday': 1,
        'sunday': 2,
        'monday': 3,
        'tuesday': 4,
        'wednesday': 5,
        'thursday': 6,
        'friday': 7,
    };

    return AllEnDays[dayValue];
}
export function kalCalculator(mealsFood, type) {
    let foodValues = { fat: 0, kcal: 0, protein: 0 }
    mealsFood.map((item) => {
        foodValues.fat += item.food.fat_per_unit * item.count;
        foodValues.kcal += item.food.kcal_per_unit * item.count;
        foodValues.protein += item.food.protein_per_unit * item.count;
    })
    if (type == "fat") {
        return (foodValues.fat).toFixed(1);
    } else if (type == "kCal") {
        return (foodValues.kcal).toFixed(1);
    } else {
        return (foodValues.protein).toFixed(1);
    }
}

export function allDayKalCalculator(meals, type) {
    let mealsFoodsValues = { fat: 0, kcal: 0, protein: 0 }
    meals.map((item) => {
        mealsFoodsValues.fat += parseFloat(kalCalculator(item.meal_foods, 'fat'));
        mealsFoodsValues.kcal += parseFloat(kalCalculator(item.meal_foods, 'kCal'));
        mealsFoodsValues.protein += parseFloat(kalCalculator(item.meal_foods, 'pr'));
    })
    if (type == "fat") {
        return mealsFoodsValues.fat.toFixed(2);
    } else if (type == "kCal") {
        return mealsFoodsValues.kcal.toFixed(2);
    } else {
        return mealsFoodsValues.protein.toFixed(2);
    }
}